/*
 * Site search — every page (owner, 2026-10-03: "a global search reachable everywhere, ideally Ctrl+K, like
 * hunger-companion.com"). A button in the top bar (and Ctrl+K / "/") opens a search window: weapons, tools,
 * consumables, hunters, traits, bestiary, charms, cosmetics, events, maps, compounds, map points, pages
 * (GET /api/search/index?lang=…, spoiler-filtered by the server, searched here as the visitor types) and
 * loadouts (GET /api/loadouts?q=…, live). Arrows move, Enter opens, Esc closes; recent picks are remembered
 * (this browser only).
 *
 * Opening a result: an app page (/arsenal, /loadouts, /codex…) goes through the app's router when it is loaded
 * (no reload); a map point on /maps through window.__huntMapsGo; anything else is a normal navigation.
 */
(function () {
	'use strict';
	if (window.__huntSearch) return;

	var LANG = function () { var l = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2); return /^[a-z]{2}$/.test(l) ? l : 'en'; };
	var ORDER = ['page', 'map', 'compound', 'weapon', 'tool', 'consumable', 'loadout', 'hunter', 'trait', 'creature', 'event', 'charm', 'cosmetic', 'poi'];
	var WEIGHT = { page: 16, map: 15, compound: 13, weapon: 11, tool: 10, consumable: 10, loadout: 9, hunter: 8, trait: 9, creature: 9, event: 7, charm: 5, cosmetic: 3, poi: 2 };
	var PER_GROUP = 5, PER_GROUP_ONLY = 30;
	var ICON = {   // types without a picture of their own
		page: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>',
		map: '<polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/><line x1="8" y1="2" x2="8" y2="18"/><line x1="16" y1="6" x2="16" y2="22"/>',
		compound: '<path d="M3 21h18"/><path d="M5 21V8l7-5 7 5v13"/><path d="M10 21v-6h4v6"/>',
		poi: '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>',
		loadout: '<rect x="3" y="7" width="18" height="13" rx="2"/><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="3" y1="13" x2="21" y2="13"/>',
		recent: '<circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/>'
	};
	var STORE = 'hunt.search.recent.v1';

	var dict = null, dictLang = null, index = null, indexLang = null, loading = null;
	var root, input, list, status, lastQ = '', rows = [], active = -1, loTimer = null, loSeq = 0, loItems = [], opener = null;

	// ---------------------------------------------------------------- texts
	function t(key, fb, vars) {
		var v = dict, p = key.split('.');
		for (var i = 0; i < p.length && v; i++) v = v[p[i]];
		var s = typeof v === 'string' ? v : fb;
		if (vars) Object.keys(vars).forEach(function (k) { s = s.replace('{' + k + '}', vars[k]); });
		return s;
	}
	function loadDict() {
		var lang = LANG();
		if (dict && dictLang === lang) return Promise.resolve();
		var url = (window.__I18N_URL || '/sounds/i18n/{lang}.json').replace('{lang}', lang);
		return fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) { if (j) { dict = j[lang] || j; dictLang = lang; } }).catch(function () {});
	}
	var GROUP = {
		page: ['search.g_pages', 'Pages'], map: ['search.g_maps', 'Maps'], compound: ['search.g_compounds', 'Compounds'], poi: ['search.g_pois', 'Map points'],
		weapon: ['search.g_weapons', 'Weapons'], tool: ['search.g_tools', 'Tools'], consumable: ['search.g_consumables', 'Consumables'],
		loadout: ['search.g_loadouts', 'Loadouts'], hunter: ['search.g_hunters', 'Hunters'], trait: ['search.g_traits', 'Traits'],
		creature: ['search.g_bestiary', 'Bestiary'], event: ['search.g_events', 'Events'], charm: ['search.g_charms', 'Charms'], cosmetic: ['search.g_cosmetics', 'Cosmetics']
	};

	// ---------------------------------------------------------------- index
	// lower case, no accents, words separated by spaces (CJK kept as is)
	function norm(s) {
		return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
	}
	function loadIndex() {
		var lang = LANG();
		if (index && indexLang === lang) return Promise.resolve(index);
		if (loading && indexLang === lang) return loading;
		indexLang = lang;
		loading = Promise.all([fetch('/api/search/index?lang=' + lang).then(function (r) { if (!r.ok) throw new Error('index'); return r.json(); }), loadDict()])
			.then(function (res) {
				index = (res[0].items || []).map(function (it) {
					return { t: it[0], name: it[1], alt: it[2], sub: it[3], url: it[4], img: it[5], n: norm(it[1]), a: norm(it[2]), s: norm(it[3]) };
				});
				return index;
			});
		loading.catch(function () { loading = null; });
		return loading;
	}

	// how well $it matches the query words (0 = not at all)
	function score(it, words, whole) {
		var sc = 0;
		for (var i = 0; i < words.length; i++) {
			var w = words[i], s = 0;
			if (it.n === w) s = 100;
			else if (it.n.indexOf(w) === 0) s = 80;
			else if ((' ' + it.n).indexOf(' ' + w) !== -1) s = 60;
			else if (it.n.indexOf(w) !== -1) s = 40;
			else if ((' ' + it.a).indexOf(' ' + w) !== -1) s = 30;
			else if (it.a.indexOf(w) !== -1) s = 20;
			else if ((' ' + it.s).indexOf(' ' + w) !== -1) s = 12;
			if (!s) return 0;
			sc += s;
		}
		if (whole && it.n === whole) sc += 60;
		else if (whole && it.n.indexOf(whole) === 0) sc += 30;
		return sc + (WEIGHT[it.t] || 0) - Math.min(it.n.length, 40) / 10;
	}
	function search(q) {
		var whole = norm(q), words = whole.split(' ').filter(Boolean);
		if (!words.length || !index) return [];
		var hits = [];
		for (var i = 0; i < index.length; i++) { var s = score(index[i], words, whole); if (s) hits.push([s, index[i]]); }
		hits.sort(function (a, b) { return b[0] - a[0]; });
		return hits.map(function (h) { return h[1]; });
	}

	// ---------------------------------------------------------------- recent picks
	function recent() { try { var r = JSON.parse(localStorage.getItem(STORE) || '[]'); return Array.isArray(r) ? r.slice(0, 6) : []; } catch (e) { return []; } }
	function remember(it) {
		try {
			var r = recent().filter(function (x) { return x.url !== it.url; });
			r.unshift({ t: it.t, name: it.name, sub: it.sub || '', url: it.url, img: it.img || '' });
			localStorage.setItem(STORE, JSON.stringify(r.slice(0, 6)));
		} catch (e) {}
	}

	// ---------------------------------------------------------------- UI
	function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
	function svg(p) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>'; }
	function mark(name, q) {   // the typed words in bold
		var words = norm(q).split(' ').filter(Boolean), out = esc(name);
		if (!words.length) return out;
		var plain = String(name).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
		if (plain.length !== String(name).length) return out;
		var marks = new Array(name.length + 1).fill(0);
		words.forEach(function (w) { var k = plain.indexOf(w); if (k !== -1) for (var i = k; i < k + w.length; i++) marks[i] = 1; });
		var s = '';
		for (var i = 0; i < name.length; i++) {
			if (marks[i] && !marks[i - 1]) s += '<b>';
			s += esc(name[i]);
			if (marks[i] && !marks[i + 1]) s += '</b>';
		}
		return s;
	}

	var cssDone = false;
	function injectCss() {
		if (cssDone) return; cssDone = true;
		var css = document.createElement('style');
		css.textContent = [
			'.hs-slot{flex:1 1 auto;min-width:0;display:flex;justify-content:center;padding:0 1rem}',
			'.topbar.has-hs .topbar-center{flex:0 1 auto}',
			'.hs-trigger{display:flex;align-items:center;gap:.6rem;width:100%;max-width:520px;height:34px;padding:0 .7rem;border:1px solid var(--border-hi,rgba(65,219,188,.35));border-radius:8px;background:var(--surface-2,#0a1722);color:var(--text-muted,#93a2b1);font:inherit;font-size:.9rem;cursor:text;min-width:0;text-align:left}',
			'.hs-trigger:hover,.hs-trigger:focus-visible{color:var(--text,#dfe4ea);border-color:var(--accent,#2ec7a5);outline:none;box-shadow:0 0 0 3px var(--accent-glow,rgba(65,219,188,.14))}',
			'.hs-trigger svg{width:16px;height:16px;flex:none;color:var(--accent,#2ec7a5)}',
			'.hs-trigger .hs-tl{flex:1;min-width:0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}',
			'.hs-trigger kbd{font:inherit;font-size:.72rem;padding:1px 5px;border-radius:4px;border:1px solid var(--border,rgba(255,255,255,.1));color:var(--text-dim,#5a6678);flex:none}',
			'@media (max-width:899px){.hs-slot{display:none}.topbar.has-hs .topbar-center{flex:1 1 auto}}',   // phones: the tab bar's Search
			'.hs-root{position:fixed;inset:0;z-index:4000;display:flex;justify-content:center;align-items:flex-start;padding:10vh 16px 16px;background:rgba(0,3,8,.72);backdrop-filter:blur(3px)}',
			'.hs-root[hidden]{display:none}',
			'.hs-box{width:100%;max-width:640px;max-height:76vh;display:flex;flex-direction:column;background:var(--surface,#061019);border:1px solid var(--border-hi,rgba(65,219,188,.35));border-radius:12px;box-shadow:0 24px 64px rgba(0,0,0,.6);overflow:hidden;color:var(--text,#dfe4ea)}',
			'.hs-head{display:flex;align-items:center;gap:.6rem;padding:.75rem .9rem;border-bottom:1px solid var(--border,rgba(255,255,255,.06))}',
			'.hs-head svg{width:20px;height:20px;color:var(--accent,#2ec7a5);flex:none}',
			'.hs-input{flex:1;min-width:0;background:none;border:0;outline:0;color:var(--text-strong,#fff);font:inherit;font-size:1.05rem}',
			'.hs-input::placeholder{color:var(--text-dim,#5a6678)}',
			'.hs-esc{font:inherit;font-size:.72rem;padding:2px 6px;border-radius:4px;border:1px solid var(--border,rgba(255,255,255,.1));background:none;color:var(--text-dim,#5a6678);cursor:pointer}',
			'.hs-list{overflow-y:auto;padding:.35rem 0 .5rem;overscroll-behavior:contain}',
			'.hs-group{padding:.6rem 1rem .25rem;font-size:.72rem;letter-spacing:.04em;color:var(--gold-hi,#d8b96a);display:flex;justify-content:space-between;align-items:baseline}',
			'.hs-more{font:inherit;font-size:.72rem;background:none;border:0;color:var(--text-muted,#93a2b1);cursor:pointer;padding:0}',
			'.hs-more:hover{color:var(--accent-hi,#41dbbc)}',
			'.hs-row{display:flex;align-items:center;gap:.7rem;padding:.42rem 1rem;color:inherit;text-decoration:none;cursor:pointer}',
			'.hs-row.is-active{background:var(--accent-glow,rgba(65,219,188,.14));box-shadow:inset 3px 0 0 var(--accent,#2ec7a5)}',
			'.hs-pic{width:40px;height:30px;flex:none;display:flex;align-items:center;justify-content:center;border-radius:6px;background:var(--surface-2,#0a1722);overflow:hidden;color:var(--text-muted,#93a2b1)}',
			'.hs-pic img{max-width:100%;max-height:100%;object-fit:contain}',
			'.hs-pic svg{width:17px;height:17px}',
			'.hs-txt{min-width:0;flex:1;display:flex;flex-direction:column}',
			'.hs-name{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--text-strong,#fff)}',
			'.hs-name b{color:var(--accent-hi,#41dbbc);font-weight:600}',
			'.hs-sub{font-size:.78rem;color:var(--text-muted,#93a2b1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
			'.hs-status{padding:1.4rem 1rem;text-align:center;color:var(--text-muted,#93a2b1)}',
			'.hs-foot{display:flex;gap:1rem;padding:.5rem 1rem;border-top:1px solid var(--border,rgba(255,255,255,.06));font-size:.74rem;color:var(--text-dim,#5a6678)}',
			'@media (max-width:600px){.hs-root{padding:0}.hs-box{max-width:none;max-height:100%;height:100%;border-radius:0;border:0}.hs-foot{display:none}}'
		].join('\n');
		document.head.appendChild(css);
	}
	function build() {
		injectCss();
		root = document.createElement('div');
		root.className = 'hs-root'; root.hidden = true;
		root.innerHTML = '<div class="hs-box" role="dialog" aria-modal="true" aria-label="Search">' +
			'<div class="hs-head">' + svg('<circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>') +
			'<input class="hs-input" type="search" autocomplete="off" spellcheck="false" role="combobox" aria-expanded="true" aria-controls="hsList" aria-autocomplete="list">' +
			'<button type="button" class="hs-esc">Esc</button></div>' +
			'<div class="hs-list" id="hsList" role="listbox"></div>' +
			'<div class="hs-foot"></div></div>';
		document.body.appendChild(root);
		input = root.querySelector('.hs-input'); list = root.querySelector('.hs-list');
		root.addEventListener('mousedown', function (e) { if (e.target === root) close(); });
		root.querySelector('.hs-esc').addEventListener('click', close);
		input.addEventListener('input', function () { render(); });
		input.addEventListener('keydown', onKey);
		list.addEventListener('click', function (e) {
			var more = e.target.closest('.hs-more');
			if (more) { e.preventDefault(); render(more.getAttribute('data-t')); input.focus(); return; }
			var a = e.target.closest('.hs-row');
			if (!a || e.ctrlKey || e.metaKey || e.shiftKey || e.button) return;
			e.preventDefault(); go(rows[+a.getAttribute('data-i')]);
		});
		list.addEventListener('mousemove', function (e) { var a = e.target.closest('.hs-row'); if (a) highlight(+a.getAttribute('data-i'), true); });
	}

	function texts() {
		input.placeholder = t('search.placeholder', 'Search weapons, hunters, compounds, loadouts…');
		root.querySelector('.hs-foot').innerHTML = '<span>' + esc(t('search.hint_keys', '↑ ↓ to move · Enter to open · Esc to close')) + '</span>';
		root.querySelector('.hs-box').setAttribute('aria-label', t('search.title', 'Search'));
	}

	function row(it, i, q) {
		var pic = it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy">' : svg(ICON[it.t] || ICON.page);
		return '<a class="hs-row" role="option" id="hsr' + i + '" data-i="' + i + '" href="' + esc(it.url) + '">' +
			'<span class="hs-pic">' + pic + '</span><span class="hs-txt"><span class="hs-name">' + mark(it.name, q) + '</span>' +
			(it.sub ? '<span class="hs-sub">' + esc(it.sub) + '</span>' : '') + '</span></a>';
	}

	// only: show every result of one type ("more")
	function render(only) {
		var q = input.value.trim();
		if (q !== lastQ) { lastQ = q; loItems = []; liveLoadouts(q); }
		rows = []; var h = '';
		if (!q) {
			var rec = recent();
			if (rec.length) {
				h += '<div class="hs-group">' + esc(t('search.recent', 'Recent')) + '</div>';
				rec.forEach(function (it) { h += row({ t: it.t, name: it.name, sub: it.sub, url: it.url, img: it.img }, rows.length, ''); rows.push(it); });
			}
			h += '<div class="hs-group">' + esc(t('search.g_pages', 'Pages')) + '</div>';
			(index || []).filter(function (it) { return it.t === 'page' && /^\/(maps\/|arsenal|loadouts|sounds\/quiz|codex|loot)$/.test(it.url); }).forEach(function (it) {
				h += row(it, rows.length, ''); rows.push(it);
			});
			list.innerHTML = h || '<div class="hs-status">' + esc(t('search.start', 'Type to search the whole site')) + '</div>';
			highlight(rows.length ? 0 : -1);
			return;
		}
		var hits = search(q).concat(loItems), groups = {};
		hits.forEach(function (it) { (groups[it.t] = groups[it.t] || []).push(it); });
		// groups in the order of their best hit, the fixed order breaking ties
		var order = ORDER.filter(function (k) { return groups[k] && (!only || k === only); });
		order.sort(function (a, b) { return hits.indexOf(groups[a][0]) - hits.indexOf(groups[b][0]); });
		order.forEach(function (k) {
			var g = groups[k], max = only ? PER_GROUP_ONLY : PER_GROUP;
			h += '<div class="hs-group"><span>' + esc(t(GROUP[k][0], GROUP[k][1])) + ' · ' + g.length + '</span>' +
				(g.length > max ? '<button type="button" class="hs-more" data-t="' + k + '">' + esc(t('search.more', 'Show all')) + '</button>' : '') + '</div>';
			g.slice(0, max).forEach(function (it) { h += row(it, rows.length, q); rows.push(it); });
		});
		list.innerHTML = h || '<div class="hs-status">' + esc(t('search.none', 'Nothing found for “{q}”', { q: q })) + '</div>';
		highlight(rows.length ? 0 : -1);
	}

	// loadouts are in the database: asked as the visitor types (3 letters at least)
	function liveLoadouts(q) {
		clearTimeout(loTimer);
		if (norm(q).length < 3) return;
		var seq = ++loSeq;
		loTimer = setTimeout(function () {
			fetch('/api/loadouts?sort=top&q=' + encodeURIComponent(q), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
				if (seq !== loSeq || !j || !j.items || input.value.trim() !== q) return;
				loItems = j.items.slice(0, 8).map(function (l) {
					var by = l.author && l.author.username ? t('search.by', 'by {user}', { user: l.author.username }) : '';
					return { t: 'loadout', name: l.name, sub: [by, '▲ ' + (l.votes || 0), l.patch].filter(Boolean).join(' · '), url: '/loadouts/' + encodeURIComponent(l.id), img: '' };
				});
				if (loItems.length) { var keep = active; render(); highlight(Math.min(keep, rows.length - 1)); }
			}).catch(function () {});
		}, 220);
	}

	function highlight(i, noScroll) {
		var els = list.querySelectorAll('.hs-row');
		if (els[active]) els[active].classList.remove('is-active');
		active = i;
		if (els[i]) {
			els[i].classList.add('is-active');
			input.setAttribute('aria-activedescendant', els[i].id);
			if (!noScroll) els[i].scrollIntoView({ block: 'nearest' });
		} else input.removeAttribute('aria-activedescendant');
	}
	function onKey(e) {
		if (e.key === 'ArrowDown') { e.preventDefault(); if (rows.length) highlight((active + 1) % rows.length); }
		else if (e.key === 'ArrowUp') { e.preventDefault(); if (rows.length) highlight((active - 1 + rows.length) % rows.length); }
		else if (e.key === 'Enter') { e.preventDefault(); if (rows[active]) go(rows[active], e.ctrlKey || e.metaKey); }
		else if (e.key === 'Escape') { e.preventDefault(); close(); }
		else if (e.key === 'Tab') { e.preventDefault(); }   // focus stays in the window
	}

	function go(it, newTab) {
		if (!it) return;
		remember(it);
		try { if (window.huntTrack) window.huntTrack('search.pick', { t: it.t, q: Math.min(lastQ.length, 40) }); } catch (e) {}
		if (newTab) { window.open(it.url, '_blank', 'noopener'); return; }
		close(true);
		var u = it.url;
		if (window.__huntRouter && /^\/(arsenal|loadouts|loot|codex|news|privacy|sounds)(\/|\?|$)/.test(u) && !/^\/sounds\/?$/.test(u)) { window.__huntRouter.navigate(u); window.scrollTo(0, 0); return; }
		if (window.__huntMapsGo && /^\/maps\//.test(u) && window.__huntMapsGo(u)) return;
		location.href = u;
	}

	function open() {
		if (!root) build();
		opener = document.activeElement;
		texts(); loadDict().then(texts);
		root.hidden = false;
		document.documentElement.style.overflow = 'hidden';
		input.value = ''; lastQ = '';
		input.focus();
		list.innerHTML = '<div class="hs-status">' + esc(t('search.loading', 'Loading…')) + '</div>';
		loadIndex().then(function () { texts(); if (!root.hidden) render(); }).catch(function () {
			list.innerHTML = '<div class="hs-status">' + esc(t('search.error', 'The search could not load. Check your connection and try again.')) + '</div>';
		});
	}
	function close(navigating) {
		if (!root || root.hidden) return;
		root.hidden = true;
		document.documentElement.style.overflow = '';
		if (!navigating && opener && opener.focus) opener.focus();
	}

	// ---------------------------------------------------------------- top bar button + shortcuts
	// The search field of the top bar: wide, in the middle of the bar on every page (a slot right after the bar's
	// left part; the page's own centre — quiz title, maps "my requests" — moves next to the right part).
	function addTrigger() {
		var bar = document.querySelector('header.topbar');
		if (!bar || document.querySelector('.hs-trigger')) return;
		injectCss();
		var slot = document.createElement('div');
		slot.className = 'hs-slot';
		var b = document.createElement('button');
		b.type = 'button'; b.className = 'hs-trigger';
		var mac = /Mac|iPhone|iPad/.test(navigator.platform || '');
		b.innerHTML = svg('<circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>') + '<span class="hs-tl">Search</span><kbd>' + (mac ? '⌘' : 'Ctrl') + ' K</kbd>';
		b.addEventListener('click', open);
		b.addEventListener('pointerenter', function () { loadIndex().catch(function () {}); }, { once: true });   // warm up
		slot.appendChild(b);
		var left = bar.querySelector('.topbar-left');
		if (left && left.nextSibling) bar.insertBefore(slot, left.nextSibling); else bar.insertBefore(slot, bar.firstChild);
		bar.classList.add('has-hs');
		var label = function () { b.querySelector('.hs-tl').textContent = t('search.placeholder', 'Search weapons, hunters, compounds, loadouts…'); b.setAttribute('aria-label', t('search.title', 'Search')); };
		loadDict().then(label);
		// app pages settle their language after loading (the <html lang> changes): follow it
		try { new MutationObserver(function () { loadDict().then(label); }).observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] }); } catch (e) {}
	}
	document.addEventListener('click', function (e) {   // any [data-open-search] (the phones' tab bar…)
		var b = e.target.closest && e.target.closest('[data-open-search]');
		if (b) { e.preventDefault(); open(); }
	});
	document.addEventListener('keydown', function (e) {
		var k = (e.key || '').toLowerCase();
		if ((e.ctrlKey || e.metaKey) && k === 'k') { e.preventDefault(); root && !root.hidden ? close() : open(); return; }
		if (k === '/' && !e.ctrlKey && !e.metaKey && !e.altKey) {
			var el = document.activeElement, tag = el && el.tagName;
			if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (el && el.isContentEditable)) return;
			e.preventDefault(); open();
		}
	});
	// the language changed (app pages): the next search uses the new language
	document.addEventListener('hunt:i18n', function () { loadDict(); });

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addTrigger); else addTrigger();
	window.__huntSearch = { open: open, close: close };
})();
